module.exports = __webpack_public_path__ + "static/media/check-image.03e5dedf.svg";